import AccordionFragment from "@/components/Accordion/Accordion.fragment";
import CarouselFragment from "@/components/Carousel/Carousel.fragment";
import DownloadButtonsFragment from "@/components/DownloadButtons/DownloadButtons.fragment";
import FeatureCardFragment from "@/components/FeatureCard/FeatureCard.fragment";
import GeneralListingFragment from "@/components/GeneralListing/GeneralListing.fragment";
import ImageComparisonFragment from "@/components/ImageComparison/ImageComparison.fragment";
import GallerySlideFragment from "@/components/ImageGallery/GallerySlide.fragment";
import ImageGalleryFragment from "@/components/ImageGallery/ImageGallery.fragment";
import ImagesFragment from "@/components/Images/Images.fragment";
import PromoBlockFragment from "@/components/PromoBlock/PromoBlock.fragment";
import TestimonialBlockQuoteFragment from "@/components/TestimonialBlockQuote/TestimonialBlockQuote.fragment";
import TextImageFragment from "@/components/TextImage/TextImage.fragment";
import VideoComponentFragment from "@/components/VideoComponent/VideoComponent.fragment";
import WYSIWYGFragment from "@/components/WYSIWYG/WYSIWYG.fragment";
import { gql } from "@apollo/client";
import { ShortHeroFragment, TallHeroFragment } from "@components/Hero/Hero.fragment";

export default gql`
  ${ShortHeroFragment}
  ${TallHeroFragment}
  ${WYSIWYGFragment}
  ${PromoBlockFragment}
  ${AccordionFragment}
  ${FeatureCardFragment}
  ${CarouselFragment}
  ${DownloadButtonsFragment}
  ${ImagesFragment}
  ${GeneralListingFragment}
  ${ImageComparisonFragment}
  ${ImageGalleryFragment}
  ${GallerySlideFragment}
  ${TestimonialBlockQuoteFragment}
  ${TextImageFragment}
  ${VideoComponentFragment}
  fragment ExperiencePageFragment on ExperienceNode {
    id
    previewEditUrl
    latestVersion
    versionStatus
    published
    hero {
      ...ShortHeroParagraph
      ...TallHeroParagraph
    }
    informationSection {
      tiles {
        label
        value
      }
    }
    metatags {
      metaTitle
      metaRobots
      metaImage {
        md
      }
      metaDescription
      canonical
    }
    breadcrumbs {
      title
      url
    }
    path
    title
    content {
      ...WYSIWYGFragment
      ...PromoBlockFragment
      ...AccordionFragment
      ...FeatureCardFragment
      ...CarouselFragment
      ...DownloadFragment
      ...ImagesFragment
      ...GeneralListingFragment
      ...ImageComparisonFragment
      ...ImageGalleryFragment
      ...GallerySlideFragment
      ...TestimonialsFragment
      ...TextImageFragment
      ...VideoComponentFragment
    }
  }
`;
